import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

// Centralized icon rendering. 
// Uses named imports exclusively across the app to prevent Vite OOM crashes
// caused by wildcard imports of react-icons in WebContainers.
const SafeIcon = ({ icon, ...props }) => {
  const IconComponent = icon;
  return IconComponent ? (
    <IconComponent {...props} />
  ) : (
    <FiAlertTriangle {...props} />
  );
};

export default SafeIcon;